"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidDate = void 0;
/**
 * Returns true if the element is a valid date
 * @public
 *
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is a valid Date or not.
 *
 * @example
 * ```ts
 * const result = isValidDate(new Date());
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidDate(arg) {
    return arg instanceof Date && !isNaN(arg.getTime());
}
exports.isValidDate = isValidDate;
//# sourceMappingURL=is-valid-date.js.map